import type { Order } from "@/types";

export type OrderRefundState =
  | { kind: "none" }
  | { kind: "pending"; pendingAmount: number }
  | { kind: "partial"; refundedAmount: number }
  | { kind: "full"; refundedAmount: number };

export function deriveRefundState(order: Order): OrderRefundState {
  const refunds = order.refunds ?? [];
  if (refunds.length === 0) return { kind: "none" };

  const refundedAmount = refunds
    .filter((r) => r.status === "approved")
    .reduce((sum, r) => sum + r.amount, 0);
  const pendingAmount = refunds
    .filter((r) => r.status === "pending")
    .reduce((sum, r) => sum + r.amount, 0);

  if (refundedAmount >= order.total && order.total > 0) {
    return { kind: "full", refundedAmount };
  }
  if (refundedAmount > 0) return { kind: "partial", refundedAmount };
  if (pendingAmount > 0) return { kind: "pending", pendingAmount };

  return { kind: "none" };
}
